export default "__VITE_ASSET__C6e4x0jz__"